import cx from "classnames";
import React from "react";

export interface CheckboxProps {
  id: string;
  value: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  disabled?: boolean;
  className?: string;
}

export function Checkbox({
  id,
  value,
  checked,
  onChange,
  label,
  disabled = false,
  className,
}: CheckboxProps) {
  return (
    <input
      type="checkbox"
      id={id}
      value={value}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      aria-label={label}
      className={cx(
        "h-4 w-4 rounded border-gray-300 text-blue-500 focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 cursor-pointer focus:outline-none",
        {
          "opacity-50 cursor-not-allowed": disabled,
        },
        className
      )}
    />
  );
}
